import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";
import { SubscribtionData } from "../../api/WickedApiClient";
import { SubscribtionService } from "../../Services/subscribtion.service";

@Component({
  selector: "app-cancel-subscription",
  templateUrl: "./cancelSubscription.component.html",
  styleUrls: ["./cancelSubscription.component.scss"]
})
export class CancelSubscriptionComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<CancelSubscriptionComponent>, @Inject(MAT_DIALOG_DATA) public data: SubscribtionData, private subscribtionService: SubscribtionService) { }

  ngOnInit() {}

    onNoClick() {
        this.dialogRef.close(false);
    }

    onYesClick() {
        this.subscribtionService.cancel(this.data.subscribtionId).then((response) => {
           
            this.dialogRef.close(true);
        });

       
    }
}
